import styled from "styled-components";

export const Error = styled.p`
  padding-top: 10px;
`;
